
import { INotice } from '@/store/notice-store';
import { Component, Prop, Vue } from "vue-property-decorator";
import PassengerAvatar from '@/components/PassengerAvatar.vue';

@Component({
  components: {
    PassengerAvatar
  },
})
export default class NoticePassengers extends Vue {
  @Prop({ required: true }) notice!: INotice;
  @Prop({ default: null }) ariaLabel!: string | null;

  get routePassengerId() {
    const rawPassengerId = this.$route.query.passengerId;

    if (!rawPassengerId) {
      return null;
    }

    const parsedPassengerId = Number.parseInt(String(rawPassengerId), 10);
    if (Number.isNaN(parsedPassengerId)) {
      return null;
    }

    return parsedPassengerId;
  }

  get passengers(): IPassenger[] {
    if (this.routePassengerId) {
      return  [this.$store.getters['passenger/passengerByMovitId'](this.routePassengerId)];
    }
      
    return this.notice.passengers
      .map((id: number) => this.$store.getters['passenger/passengerByMovitId'](id))
      .filter((passenger: IPassenger | undefined): passenger is IPassenger => Boolean(passenger));
  }

}
